try {
  var util = require('util');
  if (typeof util.inherits !== 'function') throw '';
  module.exports = util.inherits;
} catch (e) {
  module.exports = require('./inherits_browser.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/inherits/inherits.js
// module id = 40
// module chunks = 0 1